import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DeviceGroupsRoutingModule } from './device-groups-routing.module';
import { DeviceGroupsComponent } from './device-groups.component';
import { TableModule } from 'primeng/table';
import { CoreModule } from '@app/core/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MultiSelectModule } from 'primeng/multiselect';
import { SharedModule } from '../shared';


@NgModule({
  declarations: [
    DeviceGroupsComponent
  ],
  imports: [
    CommonModule,
    DeviceGroupsRoutingModule,
    TableModule,
    CoreModule,
    FormsModule,
    TranslateModule,
    RadioButtonModule,
    ButtonModule,
    ToastModule,
    NgbModule,
    SharedModule,
    MultiSelectModule
  ]
})
export class DeviceGroupsModule { }
